import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import MainDashBoard from 'model/MainDashboard'
import { dashboard, navbarDashboard, nurseDashboard } from 'user/UserApi'
import NurseDashboard from 'model/NurseDashboard'
// import Api from 'clients/web/Api'
import { PatientStatusOne } from 'model/Patient'

interface DashboardState {
  isLoadingNavbar: boolean
  nurseDashboard: NurseDashboard
  isLoadingMain: boolean
  mainDashBoard: MainDashBoard
  navbarData: any[] | undefined
}

const initialState: DashboardState = {
  nurseDashboard: {} as NurseDashboard,
  mainDashBoard: {} as MainDashBoard,
  isLoadingNavbar: false,
  isLoadingMain: false,
  navbarData: undefined,
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    startLoadingNavbar: state => {
      state.isLoadingNavbar = true
    },
    startLoadingMain: state => {
      state.isLoadingMain = true
    },
    fetchNurseDashboardSuccess: (state, { payload }: PayloadAction<NurseDashboard>) => {
      state.nurseDashboard = payload
      state.isLoadingNavbar = false
    },
    fetchMainDashboardSuccess: (state, { payload }: PayloadAction<MainDashBoard>) => {
      state.mainDashBoard = payload
      state.isLoadingMain = false
    },
    fetchNavbarDataSuccess: (state, { payload }: PayloadAction<PatientStatusOne[]>) => {
      state.navbarData = payload
      state.isLoadingNavbar = false
    },
  },
})
export const {
  startLoadingNavbar,
  startLoadingMain,
  fetchNurseDashboardSuccess,
  fetchMainDashboardSuccess,
  fetchNavbarDataSuccess,
} = dashboardSlice.actions

export const fetchNurseDashboard = (): AppThunk => async dispatch => {
  dispatch(startLoadingNavbar())
  nurseDashboard()
    .then((data: any) => {
      dispatch(
        fetchNurseDashboardSuccess({
          emergency_nurse_count: data.data.emergency_nurse_count,
          emergency_doctor_count: data.data.emergency_doctor_count,
          urgent_nurse_count: data.data.urgent_nurse_count,
          urgent_doctor_count: data.data.urgent_doctor_count,
          regular_doctor_count: data.data.regular_doctor_count,
          regular_nurse_count: data.data.regular_nurse_count,
          regular_specialist_count: data.data.regular_specialist_count,
          patientActive_count: data.data.patientActive_count,
          patientActive: data.data.patientActive,
        } as NurseDashboard),
      )
    })
    //logout user after session expires
    .catch(err => {
      if (err.response && err.response.status === 401) {
        // Api.prototype.logOut()
      }
    })
}

export const fetchMainDashboard = (): AppThunk => async dispatch => {
  dispatch(startLoadingMain())
  dashboard().then((data: any) => {
    let patientsData = data.data.patient_ages || []
    let patientsCount = data.data.patient_count

    for (let i = 0; patientsData && i < patientsData.length; i++) {
      patientsData[i].label = `${patientsData[i]._id.min}0: ${(
        (patientsData[i].count / patientsCount) *
        100
      ).toFixed(0)}%`
    }
    let appointmentsData = data.data.appointments
    for (let i = 0; appointmentsData && i < appointmentsData.length; i++) {
      appointmentsData[i].label = `${appointmentsData[i]._id.min}: ${appointmentsData[i].count}`
    }
    let appointmentsCount = data.data.appointment_count

    dispatch(
      fetchMainDashboardSuccess({
        patientsData,
        patientsCount,
        appointmentsData,
        appointmentsCount,
      }),
    )
  })
}

export const fetchNavbarData = (): AppThunk => async dispatch => {
  navbarDashboard()
    .then((res: any) => {
      dispatch(fetchNavbarDataSuccess(res.data.navbarData))
    })
    .catch(err => {
      console.log('error', err)
    })
}

export default dashboardSlice.reducer
